import React, { useState } from "react";
import { useAuth } from "@/context/AuthContext";
import api, { formatApiErrorDetail } from "@/lib/api";
import { Mail, X, Loader2 } from "lucide-react";
import { toast } from "sonner";

export default function VerifyEmailBanner() {
  const { user } = useAuth();
  const [dismissed, setDismissed] = useState(false);
  const [busy, setBusy] = useState(false);

  if (!user || user.email_verified || dismissed) return null;

  const resend = async () => {
    setBusy(true);
    try {
      await api.post("/auth/resend-verification");
      toast.success("Verification email sent — check your inbox.");
    } catch (e) {
      toast.error(formatApiErrorDetail(e.response?.data?.detail));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div
      data-testid="verify-banner"
      className="border-b border-amber-200 bg-amber-50 px-6 py-2.5 flex items-center justify-between gap-3"
    >
      <div className="flex items-center gap-3 text-sm text-amber-900">
        <Mail size={16} strokeWidth={1.8} className="text-amber-700 shrink-0" />
        <span>
          Verify your email <span className="font-semibold">{user.email}</span> to unlock account recovery and Daily Brief delivery.
        </span>
      </div>
      <div className="flex items-center gap-2 shrink-0">
        <button
          data-testid="resend-verify-button"
          onClick={resend}
          disabled={busy}
          className="inline-flex items-center gap-2 text-xs font-mono uppercase tracking-widest text-amber-900 hover:text-black border border-amber-300 hover:border-amber-700 bg-white rounded-md px-3 py-1.5 disabled:opacity-60"
        >
          {busy ? <Loader2 size={12} className="animate-spin" /> : null}
          Resend
        </button>
        <button
          onClick={() => setDismissed(true)}
          className="text-amber-700 hover:text-black"
          aria-label="Dismiss"
        >
          <X size={14} />
        </button>
      </div>
    </div>
  );
}
